import { Box, Typography, Input } from '@mui/material'
import React from 'react';
import Logo from '../Logo/Logo';
import Twitter from '../../assets/twitter.svg';
import Facebook from '../../assets/facebook.svg';
import Whatsapp from '../../assets/whatsapp.svg';
import Send from '../../assets/send.svg';
import Copywright from '../../assets/copywright.svg'
import { Link, NavLink } from 'react-router-dom';

const Footer = () => {
  var dateobj = new Date();
  var dateObject = dateobj.getFullYear();
  const token = localStorage.getItem('token');

  const product__categories = [
    {
      title: 'Gift Shop',
      path:`/product/giftshop?authToken=${token}`
    },
    {
      title: 'Digital Courses',
      path:`/product/digital-courses?authToken=${token}`
    },
   
    {
      title: ' My P2P Products',
      path:`/product/ptwop?authToken=${token}`
    },
    {
      title: 'P2P Marketplace',
      path:`/product/marketplace?authToken=${token}`
    },
    {
      title: 'Gift Card',
      path:''
    },
    {
      title: 'Airtime & Data',
      path:''
    }
  ]
  const about__links = [
    {
      title: 'Order History',
      path:'/product/digital-courses/order-history'
    },
    {
      title: 'Track Order',
      path:'/'
    },
    {
      title: 'My Dashboard',
      path:'https://mydarads.com/dashboard/makeorder'
    },
    {
      title: 'My Favourites',
      path:'/product/digital-courses/favourite'
    }
  ]
  return (
    <Box sx={{ width: '100%', borderTop: '1px solid #E6D9FE', backgroundColor:'#FBFAFF',fontFamily: theme=> theme.typography.smallText,}}>
      <Box sx={{width: '100%', display:'flex', flexWrap:'wrap', alignItems:'center', justifyContent:'space-between', p:'2rem 2rem 0 2rem'}}>
        <Box sx={{paddingLeft: '0px', width:{xs:'100%', md:'30%'}, mb:{xs:'2rem', md:'0'}}}>
          <Logo/>
          <Typography sx={{ color: 'black', my:'1.2rem' }}>
            Your trusted source for gift cards, airtime and  data, unique gifts, and more
          </Typography>
          <Box component="section" sx={{ display:'flex', gap: '1rem' }}>
            <img src={Twitter} alt="twitter logo" />
            <img src={Facebook} alt="facebook logo" />
            <img src={Whatsapp} alt="whatsapp logo" />
          </Box>
        </Box>
        <Box sx={{display:{xs:'block', sm:'flex'}, justifyContent:{xs:'space-between',sm:'start'}, alignItems:'end', width:{xs:'100%', md:'60%'}}}>
          <Box sx={{mb:{xs:'2rem', md:'0'}, display:'flex', justifyContent:{xs:'space-between',sm:'start'}, gap:{sm:'3rem'}, width:{xs:'100%', md:'60%'}}}>
            <Box>
              <Typography variant="h6" sx={{ color: 'black', fontWeight:600}}>
              Products
              </Typography>
              {
                product__categories.map((item, index)=>{
                  return <NavLink style={{color:'inherit'}} to={item.path}><Typography key={index} sx={{my:'.5rem'}}>{item.title}</Typography></NavLink>
                })
              }
            </Box>
            <Box>
            <Typography variant="h6" sx={{ color: 'black', fontWeight:600}}>
              About
              </Typography>
              {
                about__links.map((item, index)=>{
                  return <NavLink style={{color:'inherit'}} to={item.path}><Typography key= {index} sx={{my:'.5rem'}}>{item.title}</Typography></NavLink>
                })
              }
            </Box>
          </Box>
          <Box sx={{width:{xs:'100%', md:'40%'}}}>
            <Typography variant="h6" component="p" sx={{ color: 'black',fontWeight:600}}>
              Suscribe to our Newsletter
            </Typography>
            <Typography sx={{ color: 'black', my:'.3rem' }}>
              receive latest products from our services 
            </Typography>
            <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center', border: '1px solid rgba(0,0,0,0.2)', height:'60px', px:2, borderRadius:'36px', mt:'1.2rem', backgroundColor:'#fff'}}>
              <Input disableUnderline placeholder='Your Email' sx={{width:'80%'}}/>
              <Box sx={{backgroundColor:'#5604F6', width:'40px', height:'40px', borderRadius:'50%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                <img src={Send} alt="send button"/>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{display:{xs:'block', md:'flex'}, justifyContent:'space-between', mt:'3rem', backgroundColor:'#5604F6', p:'1rem 2rem'}}>
        <Box>
          <Link to={'https://www.kaybilltech.com/'} target='_blank'>
          <Typography sx={{ color: '#fff', textAlign:{xs:'center', md:'left'}}}>
            <span>Designed and Developed By</span> <span style={{color:'#F6A704'}}>kaybill Technologies Ltd </span>
          </Typography>
          </Link>
          </Box>
          <Typography sx={{ display:'flex', justifyContent:'center', gap:1, color: '#fff' }}>
            <span>Copyright </span>
            <img src={Copywright} alt="" />
             <span>mydarads,{dateObject}</span>
          </Typography>
      </Box>
    </Box>
  )
}

export default Footer